// extracted by mini-css-extract-plugin
module.exports = {"midGreyColour":"#868686","darkGreyColour":"#3A3A3A","primaryDarkColour":"#05ABA4","container":"BenefitsBanner-module--container--1TZ8E"};